import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import { installAdminFetch } from './utils/adminSession';
import { captureServerHead } from './utils/serverHead';

captureServerHead();
installAdminFetch();

window.addEventListener('error', (event) => {
  const message = String(event.message || (event.error && event.error.message) || '');
  if (message.includes('ResizeObserver loop')) {
    event.stopImmediatePropagation();
    const frame = document.getElementById('webpack-dev-server-client-overlay');
    if (frame) frame.remove();
  }
}, true);
const hideBenignCalendarWarning = () => {
  const frame = document.getElementById('webpack-dev-server-client-overlay');
  if (!(frame instanceof HTMLIFrameElement) || !frame.contentDocument || !frame.contentDocument.body) return;
  const text = frame.contentDocument.body.innerText || '';
  if (text.includes('ResizeObserver loop') && !/TypeError|ReferenceError|SyntaxError/.test(text)) frame.remove();
};
new MutationObserver(hideBenignCalendarWarning).observe(document.documentElement, { childList: true, subtree: true });
document.documentElement.dataset.calendarGuard = '1';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
